"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarToggleButton_unstable", {
    enumerable: true,
    get: ()=>useToolbarToggleButton_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactButton = require("@fluentui/react-button");
const _toolbarContext = require("../Toolbar/ToolbarContext");
const useToolbarToggleButton_unstable = (props, ref)=>{
    const handleToggleButton = (0, _toolbarContext.useToolbarContext_unstable)((ctx)=>ctx.handleToggleButton);
    const checked = (0, _toolbarContext.useToolbarContext_unstable)((ctx)=>{
        var _ctx_checkedValues_props_name;
        return !!((_ctx_checkedValues_props_name = ctx.checkedValues[props.name]) === null || _ctx_checkedValues_props_name === void 0 ? void 0 : _ctx_checkedValues_props_name.includes(props.value));
    });
    const size = (0, _toolbarContext.useToolbarContext_unstable)((ctx)=>ctx.size);
    const { onClick: onClickOriginal  } = props;
    const toggleButtonState = (0, _reactButton.useToggleButton_unstable)({
        size,
        checked,
        ...props
    }, ref);
    const state = {
        ...toggleButtonState,
        name: props.name,
        value: props.value
    };
    const handleOnClick = (e)=>{
        if (state.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        handleToggleButton === null || handleToggleButton === void 0 ? void 0 : handleToggleButton(e, state.name, state.value, state.checked);
        onClickOriginal === null || onClickOriginal === void 0 ? void 0 : onClickOriginal(e);
    };
    state.root.onClick = handleOnClick;
    return state;
}; //# sourceMappingURL=useToolbarToggleButton.js.map

//# sourceMappingURL=useToolbarToggleButton.js.map